jQuery(function($){
    $('.related-product-slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
            breakpoint: 1024, // tablet breakpoint
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 800, // mobile breakpoint
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
        ,
        {
            breakpoint: 580, // mobile breakpoint
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
    });
  	
  	$('.featured-product-slider-wrap').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
            breakpoint: 1024, // tablet breakpoint
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 800, // mobile breakpoint
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
        ,
        {
            breakpoint: 580, // mobile breakpoint
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
    });
  

      $('.category-box h3').on('click', function(e){
          e.preventDefault();
          $(this).parent().toggleClass('show-category');
      });


  $("ul.site-nav li:first-child a").click(function(e){
		e.preventDefault();
        window.open("https://www.saltstrong.com/ ");

    })
  
  $('.category-pop').on('click', function(e){
    e.preventDefault();
    $('.alt-popup').toggle();
  });
  
  $('.alt-popup-close a').on('click', function(e){
    e.preventDefault();
    $('.alt-popup').hide();
  });
  
  $(".dropdown-btn").click(function(){
    $(this).toggleClass( "active" );
    var dropdownContent = $(this).parent().next();
    if ( $(this).next().is(":visible")){
      $(this).next().css("display", "none");
      console.log('block');
      } else {
      $(this).next().css("display", "block");
        console.log('none');
      }
  });
  
});
